import React from 'react';
import './Privacy.scss';

const AvisoDePrivacidad: React.FC = () => {
  return (
    <div className="legal">
      <div className="container">
        <p className="legal__label">Legal</p>
        <h1 className="legal__title">Aviso de Privacidad</h1>
        <p className="legal__intro">
          <strong>CODIFICACIÓN TECNOLÓGICA, S. DE R.L. DE C.V.</strong> (en lo sucesivo,{' '}
          <strong>"CODETREND"</strong>), con domicilio en calle Antiguo Camino a Tesistán 8465,
          Villafontana Diamante, Zapopan, Jalisco, código postal 45200 es responsable del
          tratamiento de sus datos personales, conforme a lo dispuesto en los artículos 15, 16 y
          demás aplicables de la Ley Federal de Protección de Datos Personales en Posesión de
          los Particulares (LFPDPPP).
        </p>

        <section className="legal__section">
          <h2>Finalidades del tratamiento de datos</h2>
          <p>Los datos personales recabados se utilizarán para las siguientes finalidades:</p>

          <h3>Finalidades primarias (indispensables para la relación jurídica)</h3>
          <ul>
            <li>Cumplir con las obligaciones derivadas de relaciones contractuales de prestación de servicios, comerciales, laborales o de cualquier otra índole.</li>
            <li>Proveer los servicios contratados, incluyendo plataformas de gestión de talento, plataformas de aprendizaje y creación de contenidos e-learning.</li>
            <li>Elaborar la documentación necesaria para integrar expedientes y mantener actualizada la información relacionada con la relación contractual.</li>
            <li>Realizar cargos y pagos correspondientes a servicios, salarios o contraprestaciones.</li>
            <li>Cumplir obligaciones legales en materia laboral, fiscal, de seguridad social y demás aplicables.</li>
            <li>Garantizar el acceso y funcionamiento de las plataformas para los usuarios de nuestros clientes.</li>
            <li>Confidencialidad de la información respecto de sus datos personales recabados, misma que subsistirá aun después de finalizar las relaciones comerciales o de otra naturaleza.</li>
          </ul>

          <h3>Finalidades secundarias (no indispensables)</h3>
          <ul>
            <li>Fines mercadotécnicos, publicitarios y de prospección comercial.</li>
            <li>Estadística, métricas de uso y evaluación de calidad de los servicios.</li>
            <li>Comunicación de políticas y actualizaciones de la empresa.</li>
          </ul>
          <p>
            Usted puede manifestar su negativa al tratamiento de sus datos para finalidades
            secundarias en cualquier momento, sin que ello afecte la prestación de los servicios
            contratados.
          </p>
        </section>

        <section className="legal__section">
          <h2>Datos personales que recabamos</h2>
          <p>CODETREND recabará datos de identificación y contacto tales como:</p>
          <ul>
            <li>Nombre completo, edad, fecha de nacimiento, sexo, estado civil, CURP y RFC.</li>
            <li>Número de seguridad social, domicilio, teléfono, correo electrónico.</li>
            <li>Copias de identificaciones oficiales y datos fiscales.</li>
            <li>Datos bancarios o relacionados con ingresos económicos.</li>
            <li>Firma autógrafa y demás información necesaria para el cumplimiento de las finalidades descritas.</li>
          </ul>
          <p>
            CODETREND no recaba datos personales sensibles salvo que, por disposición legal o
            contractual, sea estrictamente necesario. En tal caso, se solicitará su
            consentimiento expreso y por escrito.
          </p>
          <p>
            Los datos podrán recabarse por medios físicos, electrónicos o digitales, incluyendo
            plataformas propias, correo electrónico, página web, redes sociales, mensajería
            instantánea, llamadas telefónicas, contratos escritos o electrónicos, entre otros.
          </p>
        </section>

        <section className="legal__section">
          <h2>Rol de los clientes en la recolección de datos personales</h2>
          <p>
            Durante la prestación del servicio de suscripción a nuestras plataformas de gestión
            de talento y aprendizaje, CODETREND puede alojar datos personales de los usuarios
            únicamente para cumplir con la relación contractual.
          </p>
          <p>
            No obstante, los clientes de CODETREND (personas físicas o morales que contratan
            nuestros servicios) también tienen acceso a los datos de sus usuarios. En este sentido:
          </p>
          <ul>
            <li>Cada cliente es responsable de contar con su propio Aviso de Privacidad, conforme a la LFPDPPP.</li>
            <li>Los clientes deben implementar medidas administrativas, técnicas y físicas para proteger la información a la que acceden.</li>
            <li>CODETREND no asume responsabilidad por el uso, tratamiento o decisiones adoptadas por los clientes respecto a los datos de sus propios usuarios, más allá de las obligaciones legales que le corresponden como proveedor tecnológico.</li>
          </ul>
          <p>
            CODETREND, por su parte, se compromete a aplicar medidas de seguridad y a
            garantizar un tratamiento adecuado de los datos alojados en sus plataformas.
          </p>
        </section>

        <section className="legal__section">
          <h2>Aviso sobre cookies y web beacons</h2>
          <p>
            CODETREND utiliza varias tecnologías para mejorar la eficiencia de sus sitios web,
            incluyendo su experiencia cuando navega por dichos sitios. Entre estas tecnologías
            se incluye el uso de cookies.
          </p>
          <p>
            Las cookies son pequeñas cantidades de información que se almacenan en el navegador
            utilizado por cada usuario para que el servidor recuerde cierta información que
            posteriormente pueda utilizar. Esta información permite identificarle y guardar sus
            preferencias personales para brindarle una mejor experiencia de navegación. Por su
            parte, las web beacons son imágenes insertadas en una página de Internet o correo
            electrónico, que puede ser utilizado para monitorear el comportamiento de un
            visitante, como almacenar información sobre la dirección IP del usuario, duración
            del tiempo de interacción en dicha página y el tipo de navegador utilizado, entre
            otros.
          </p>
        </section>

        <section className="legal__section">
          <h2>Transferencia de datos</h2>
          <p>
            Conforme al artículo 37 de la LFPDPPP, sus datos personales podrán ser transferidos,
            sin requerir consentimiento, a:
          </p>
          <ul>
            <li>Subsidiarias, filiales, proveedores y prestadores de servicios que colaboren con CODETREND.</li>
            <li>Clientes que contraten nuestras plataformas, únicamente para cumplir con la relación contractual.</li>
            <li>Autoridades competentes que lo soliciten conforme a la normativa aplicable.</li>
          </ul>
          <p>
            En casos distintos a los previstos en el artículo 37, se requerirá su consentimiento
            expreso. Si usted no manifiesta su negativa, entenderemos otorgado el consentimiento
            tácito.
          </p>
          <p>
            En caso de transferencias internacionales, CODETREND adoptará medidas contractuales
            que garanticen un tratamiento conforme a la Ley.
          </p>
        </section>

        <section className="legal__section">
          <h2>Medidas de seguridad</h2>
          <p>
            CODETREND aplica medidas administrativas, técnicas y físicas razonables para
            proteger los datos personales contra daño, pérdida, alteración, destrucción o uso no
            autorizado, en apego a los artículos 60 a 68 del Reglamento de la LFPDPPP.
          </p>
        </section>

        <section className="legal__section">
          <h2>Derechos ARCO y revocación del consentimiento</h2>
          <p>
            Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse (Derechos ARCO) al
            tratamiento de sus datos personales, así como a revocar el consentimiento otorgado.
          </p>
          <p>La solicitud deberá enviarse a través de los siguientes medios:</p>
          <ul>
            <li>Correo electrónico: <a href="mailto:contactus@codetrend.com">contactus@codetrend.com</a></li>
          </ul>
          <p>La solicitud deberá contener:</p>
          <ul>
            <li>Nombre completo y domicilio u otro medio para recibir notificaciones.</li>
            <li>Documentos que acrediten su identidad o representación legal.</li>
            <li>Descripción clara de los datos sobre los que se ejerce el derecho.</li>
            <li>Cualquier elemento que facilite la localización de los datos.</li>
          </ul>
          <p>
            CODETREND dará respuesta en un plazo máximo de 20 días hábiles, prorrogable por otro
            periodo igual en casos justificados.
          </p>
          <p>
            Si considera que no se ha dado respuesta adecuada a su solicitud, podrá acudir ante
            el Instituto Nacional de Transparencia, Acceso a la Información y Protección de
            Datos Personales (INAI).
          </p>
        </section>

        <section className="legal__section">
          <h2>Actualizaciones</h2>
          <p>
            Este Aviso de Privacidad podrá ser modificado en función de cambios normativos,
            internos o de negocio. Las actualizaciones estarán disponibles en la sección Aviso
            de Privacidad de nuestro sitio web oficial:{' '}
            <a href="https://www.codetrend.com/aviso-de-privacidad">
              https://www.codetrend.com/aviso-de-privacidad
            </a>.
          </p>
        </section>

      </div>
    </div>
  );
};

export default AvisoDePrivacidad;
